'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { Container } from '@/app/components/layouts/container';
import { Section } from '@/app/components/layouts/section';
import { PaginationDash } from '@/app/components/navigation/pagination';
import { Sliders } from '@/app/components/sliders';
import { SliderContent } from '@/app/cv/components/sections/products/hero-banner/sliders/content';
import type { ProductBannerItemProps } from '@/app/cv/components/sections/products/types';
import { useInView } from '@/app/hooks/useInView';
import { useMediaSlider } from '@/app/hooks/useMediaSlider';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
const BANNER_AUTOPLAY_MS = 8000; // 8 seconds
const BANNER_MAX_SLIDES = 9;
interface ProductHeroBannerSlidersProps {
  items?: ProductBannerItemProps[];
}
export const ProductHeroBannerSliders = t0 => {
  const $ = _c(19);
  const {
    items: t1
  } = t0;
  const items = t1 === undefined ? [] : t1;
  const sectionRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      rootMargin: "-10% 0px -10% 0px",
      threshold: 0.1,
      once: false
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const inView = useInView(sectionRef, t2);
  const {
    setEmblaApi,
    paginationItemsRefs,
    currentPage,
    onPageChange
  } = useMediaSlider({
    inView,
    items: items.map(_temp),
    imageDuration: BANNER_AUTOPLAY_MS / 1000
  });
  if (items.length === 0) {
    return null;
  }
  const visibleItems = items.slice(0, BANNER_MAX_SLIDES);
  const T0 = Section;
  const t3 = "none";
  const t4 = "aspect-3-4 lg:aspect-16-9 relative xl:rounded-md";
  const t5 = "div";
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = createDataAttributes({
      test: "product-banner-sliders"
    });
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const T1 = Sliders;
  const t7 = "absolute inset-0";
  const t8 = "gap-x-0 h-full";
  const t9 = visibleItems.length > 1;
  let t10;
  if ($[2] !== t9) {
    t10 = {
      watchDrag: t9
    };
    $[2] = t9;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const t11 = visibleItems.map((item, index) => <SliderContent key={index} index={index} item={item} multiSlide={visibleItems.length > 1} isActive={index + 1 === currentPage} />);
  let t12;
  if ($[4] !== T1 || $[5] !== setEmblaApi || $[6] !== t10 || $[7] !== t11) {
    t12 = <T1 className={t7} containerClassName={t8} onEmblaInit={setEmblaApi} emblaOptions={t10}>{t11}</T1>;
    $[4] = T1;
    $[5] = setEmblaApi;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  let t13;
  if ($[9] !== currentPage || $[10] !== onPageChange || $[11] !== paginationItemsRefs || $[12] !== visibleItems.length) {
    t13 = visibleItems.length > 1 && <Container className="pointer-events-none absolute inset-x-0 bottom-9 z-20 px-4 md:bottom-12 md:px-10 lg:px-0 xl:bottom-16"><PaginationDash itemRefs={paginationItemsRefs} theme="light" className="bg-white/30" progressClassName="bg-white" wrapperClassName="pointer-events-auto justify-center xl:justify-start" totalPages={visibleItems.length} currentPage={currentPage} onPageChange={onPageChange} isAnimated={true} /></Container>;
    $[9] = currentPage;
    $[10] = onPageChange;
    $[11] = paginationItemsRefs;
    $[12] = visibleItems.length;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== T0 || $[15] !== t12 || $[16] !== t13 || $[17] !== t6) {
    t14 = <T0 ref={sectionRef} size={t3} className={t4} as={t5} {...t6}>{t12}{t13}</T0>;
    $[14] = T0;
    $[15] = t12;
    $[16] = t13;
    $[17] = t6;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  return t14;
};
function _temp() {}